import React, { useRef, useState, useEffect } from "react";
import { Accordion } from "react-bootstrap";
import Table from "react-bootstrap/Table";

// FontAwesome
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleUp } from "@fortawesome/free-solid-svg-icons";

//custom css
import styles from "./FAQ.module.css";

const FAQ = () => {
  // const [showTopBtn, setShowTopBtn] = useState(false);
  // useEffect(() => {
  //   window.addEventListener("scroll", () => {
  //     console.log("Scrolling...");
  //     if (window.scrollY > 400) {
  //       setShowTopBtn(true);
  //     } else {
  //       setShowTopBtn(false);
  //     }
  //   });
  // }, []);

  const scrollToRef = (elem) => {
    // let position = elem.current.offsetTop + 200;
    // console.log(elem.current.offsetTop, position);

    elem.current?.scrollIntoView({
      behavior: "smooth",
    });

    // window.scrollTo({
    //   top: elem.current.offsetTop,
    //   behavior: "smooth",
    // });
  };

  const tableOfContent = useRef(null);
  const aboutAvSecID = useRef(null);
  const eligibility = useRef(null);
  const howToApply = useRef(null);
  const DAS = useRef(null);
  const bcPV = useRef(null);
  const GSAT = useRef(null);
  const useOfAvSecID = useRef(null);
  const renewal = useRef(null);
  const damaged = useRef(null);
  const lost = useRef(null);
  const foreigner = useRef(null);
  const payment = useRef(null);
  const approval = useRef(null);
  const collection = useRef(null);
  const noAvSecID = useRef(null);
  const cancellation = useRef(null);
  const documentsRequired = useRef(null);

  return (
    <div className={styles.container} ref={tableOfContent}>
      <h1 className={styles.header}>
        FREQUENTLY ASKED QUESTIONS ON AVIATION SECURITY IDENTIFICATION CARD
        (AvSecID)
      </h1>

      <div
        className={styles.scrollToTopIcon}
        onClick={() => scrollToRef(tableOfContent)}
      >
        <FontAwesomeIcon
          className={styles.scrollTopIcon}
          icon={faAngleDoubleUp}
        />
      </div>

      <>
        <h3 className={styles.subHeader}>Table of Content</h3>
        <ul className={styles.fontItalics}>
          <li
            className={styles.clickable}
            onClick={() => scrollToRef(aboutAvSecID)}
          >
            ABOUT AvSecID
          </li>
          <li
            className={styles.clickable}
            onClick={() => scrollToRef(eligibility)}
          >
            ELIGIBILITY
          </li>
          <li
            className={styles.clickable}
            onClick={() => scrollToRef(howToApply)}
          >
            HOW TO APPLY
          </li>
          <li className={styles.clickable} onClick={() => scrollToRef(DAS)}>
            DESIGNATED AUTHORIZED SIGNATORY
          </li>
          <li className={styles.clickable} onClick={() => scrollToRef(bcPV)}>
            BACKGROUND CHECKS AND POLICE VERIFICATION
          </li>
          <li className={styles.clickable} onClick={() => scrollToRef(GSAT)}>
            GENERAL SECURITY AWARENESS TRAINING (GSAT)
          </li>
          <li
            className={styles.clickable}
            onClick={() => scrollToRef(useOfAvSecID)}
          >
            USE OF AvSecID
          </li>
          <li className={styles.clickable} onClick={() => scrollToRef(renewal)}>
            RENEWAL / RE-ISSUE OF AvSecID
          </li>
          <li className={styles.clickable} onClick={() => scrollToRef(damaged)}>
            DAMAGED AND CRACKED AvSecID
          </li>
          <li className={styles.clickable} onClick={() => scrollToRef(lost)}>
            LOST OR STOLEN AvSecID
          </li>
          <li
            className={styles.clickable}
            onClick={() => scrollToRef(foreigner)}
          >
            I AM A FOREIGNER
          </li>
          <li className={styles.clickable} onClick={() => scrollToRef(payment)}>
            PAYMENT FOR AvSecID
          </li>
          <li
            className={styles.clickable}
            onClick={() => scrollToRef(approval)}
          >
            REQUIRED TIME FOR APPROVAL
          </li>
          <li
            className={styles.clickable}
            onClick={() => scrollToRef(collection)}
          >
            COLLECTING AvSecID
          </li>
          <li
            className={styles.clickable}
            onClick={() => scrollToRef(noAvSecID)}
          >
            I DON’T HAVE AvSecID
          </li>
          <li
            className={styles.clickable}
            onClick={() => scrollToRef(cancellation)}
          >
            CANCELLATION, SUSPENSION AND REVOCATION
          </li>
          <li
            className={styles.clickable}
            onClick={() => scrollToRef(documentsRequired)}
          >
            DOCUMENTS REQUIRED DURING APPLICATION
          </li>
        </ul>
      </>

      <>
        <h3 className={styles.subHeader} ref={aboutAvSecID}>
          ABOUT AvSecID
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>What is AvSecID?</Accordion.Header>
            <Accordion.Body>
              AvSecID is an acceptable identification or authorization for a
              person or vehicle to be granted unescorted or escorted access to
              airside, security-restricted areas and controlled areas of any
              CAAB’s airport.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              What are the categories of AvSecID for persons?
            </Accordion.Header>
            <Accordion.Body>
              Airport Security Pass (ASP) <br />
              National Airport Pass (NAP) <br />
              National Inspector Authorization Card (NIAC) <br />
              Crew Member Airport Pass (CMAP)
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              What are the categories of AvSecID for vehicles?
            </Accordion.Header>
            <Accordion.Body>
              Permanent Airside Vehicle Pass (PAVP) <br />
              Temporary Airside Vehicle Pass (TAVP) <br />
              Escorted Airside Vehicle Pass (EAVP)
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={eligibility}>
          ELIGIBILITY
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              Who is eligible for obtaining an AvSecID?
            </Accordion.Header>
            <Accordion.Body>
              Persons and vehicles of government organizations, air transport
              business entities, airport business entities and other authorized
              entities who have an{" "}
              <span className={styles.textUnderline}>operational business</span>{" "}
              and{" "}
              <span className={styles.textUnderline}>legitimate reason</span> to
              gain access into the airside, security restricted areas (SRA) and
              controlled areas of any CAAB airport.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              Who is eligible to apply for an Airport Security Pass (ASP)?
            </Accordion.Header>
            <Accordion.Body>
              Any individuals employed at the airport and require frequent entry
              for operational purpose or those who otherwise have a regular
              legitimate reason to access the airside and/or security-restricted
              areas and/or controlled areas of the airport and are authorized by
              the employer shall be issued with an airport security pass.
              Persons who successfully completed the Background Checks by
              Employer and Background Checks by the Special Branch of Bangladesh
              Police shall be issued with Permanent Airport Security Pass
              (PASP)that allows unescorted access with a maximum validity of 2
              years. A person whose Background Checks by the Special Branch of
              Bangladesh Police have not been completed shall be issued with a
              Temporary Airport Security Pass (TASP) with a maximum of 90
              (ninety) days of validity. A TASP shall not be renewed unless a
              valid reason is established. A TASP holder shall be escorted at
              times while entering, remaining and exiting airside, SRAs and
              other designated security areas of an airport.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              Who is eligible to apply for a National Airport Pass (NAP)?
            </Accordion.Header>
            <Accordion.Body>
              NAP shall only be issued to a few designated CAAB officials
              nominated by the Chairman, CAAB for a period not exceeding 2
              years. The NAP will be ceased upon posting out from CAAB.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              Who is eligible to apply for a National Inspector Authorization
              Card (NIAC)?
            </Accordion.Header>
            <Accordion.Body>
              NIAC shall be issued to a person who is authorized by the
              Chairman, CAAB as a national aviation safety inspector or national
              aviation security inspector under section 11 and 40 of the Civil
              Aviation Act 2017. NIAC shall be issued for a period not exceeding
              3 (three) years.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>
              Who is eligible to apply for a Crew Member Airport Pass (CMAP)?
            </Accordion.Header>
            <Accordion.Body>
              CMAP shall be issued to a crew member employed by a Bangladeshi
              aircraft operator who has an operational need and has successfully
              completed a background check and police verification checks in
              accordance with CAAB requirements. CMAP shall be issued for a
              period not exceeding 2 (two) years.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5">
            <Accordion.Header>
              Who is eligible to apply for a Permanent Airside Vehicle Pass
              (PAVP)?
            </Accordion.Header>
            <Accordion.Body>
              PAVP shall be issued to the operational vehicles and equipment
              that generally remain within the airside and require regular
              movement to and from the airside.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6">
            <Accordion.Header>
              Who is eligible to apply for a Temporary Airside Vehicle Pass
              (TAVP)?
            </Accordion.Header>
            <Accordion.Body>
              TAVP shall be issued to any vehicle granted temporary access to
              airside as replacement of vehicle issued with PAVP.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="7">
            <Accordion.Header>
              Who is eligible to apply for an Escorted Airside Vehicle Pass
              (EAVP)?
            </Accordion.Header>
            <Accordion.Body>
              EAVP shall be issued to the following vehicles requiring
              occasional access to airside such as construction vehicles, cargo
              and mail vehicles, medical ambulances and any other vehicle
              permitted by the authority.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={howToApply}>
          HOW TO APPLY
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              What does the AvSecID application process involve?
            </Accordion.Header>
            <Accordion.Body>
              Step-1: sign-up at http://avsec.caab.gov.bd/ and complete your
              profile. <br />
              Step-2: Click “New Application”. then you will be asked to enter{" "}
              <span className={styles.textUnderline}>
                5 digit Organization Code
              </span>
              . If you don’t know the code, please contact the [Designated
              Authorized Signatory (DAS) of your organization]
              <br />
              Step-3: Complete the application and submit it to the Designated
              Authorized Signatory (DAS) of your organization.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              How do I get the organization code for the AvSeCID portal?
            </Accordion.Header>
            <Accordion.Body>
              If you don’t know the organization’s code, please contact your
              DAS.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              How do I enlist my organization in the AvSecID portal?
            </Accordion.Header>
            <Accordion.Body>
              Please, contact AVSEC Division, Headquarters, Civil Aviation
              Authority of Bangladesh, if you are one of the following
              organizations with operational needs and/or legitimate reasons to
              enter the airports: Government entity <br />
              Air transport business entity <br />
              Airport business entity
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              I am not an enlisted organization of CAAB’s airport, but I have an
              existing contract with a CAAB Airport Organization. Can I apply
              for an ASP?
            </Accordion.Header>
            <Accordion.Body>
              Yes, your contracted organization will lodge your application
              through the designated authorized signatory of your contracted
              organization.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={DAS}>
          DESIGNATED AUTHORIZED SIGNATORY
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              What does mean Designated Authorized Signatory (DAS)?
            </Accordion.Header>
            <Accordion.Body>
              Designated Authorized Signatory is the nominated employee of a
              registered organization enlisted in the AvSecID portal. Only DAS
              can forward an individual application of AvSecID.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              What are the roles of the Designated Authorized Signatory (DAS)?
            </Accordion.Header>
            <Accordion.Body>
              Validate and request individual AvSecID applications and
              documentation for his department/organization.
              <br />
              Ensure that documentations for pass applications are genuine,
              accurate, and complete.
              <br />
              Ensure the required employer background checks and where
              applicable police verification has been conducted on the
              applicant. <br />
              Verify the areas of access or authorization required for the
              performance of the applicant’s current responsibilities.
              <br />
              Follow up on application problems that may arise
              <br />
              Notify the airport pass office immediately of lost, stolen or
              changes in employee employment status.
              <br />
              Provide a timely response to audit/inspection.
              <br />
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              How do I become/nominate a Designated Authorized Signatory (DAS)?
            </Accordion.Header>
            <Accordion.Body>
              Please visit the link: DAS.pdf (caab.gov.bd)
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={bcPV}>
          BACKGROUND CHECKS AND POLICE VERIFICATION
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              What are the Background Checks and Police Verification
              requirements for obtaining one of AvSecID for persons?
            </Accordion.Header>
            <Accordion.Body>
              Following background checks are mandatory for obtaining any one of
              AvSecID with unescorted access to airside, Security Restricted
              Areas and other designated areas of an airport:
              <br />
              Background Checks by the employer (BCE)
              <br />
              Background Checks by the Special Branch of Bangladesh Police
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={GSAT}>
          GENERAL SECURITY AWARENESS TRAINING (GSAT)
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              What is the GSAT requirements for AvSecID holders?
            </Accordion.Header>
            <Accordion.Body>
              GSAT stands for General Security Awareness Training and
              pre-requisite for being allowed unescorted access to airside,
              security restricted areas and other designated security areas of
              airports in accordance with international obligations and national
              requirements. Persons applying for AvSecID will be asked to upload
              their GSAT certificate during the application/DAS
              verification/before approval/before issuance of AvSecID from pass
              office.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              What are the categories of GSAT?
            </Accordion.Header>
            <Accordion.Body>
              GSAT (General) <br />
              GSAT (Cargo)
              <br />
              Cargo Operative Course (RA3)
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              Who should receive GSAT (General)?
            </Accordion.Header>
            <Accordion.Body>
              In accordance with the national requirements, all personnel
              involved with or responsible for the implementation of various
              aspects of the national civil aviation security programme and
              those authorized to have unescorted access to airside and / or
              security restricted areas and /or other security designated areas
              of airport are required to undergo GSAT (General).
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              Who should receive GSAT (Cargo)?
            </Accordion.Header>
            <Accordion.Body>
              All person with unescorted access to secure cargo should have
              received the GSAT (Cargo) in addition.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>
              Who should receive Cargo Operative Course (RA3)?
            </Accordion.Header>
            <Accordion.Body>
              All persons with unescorted access to RA3 Facilities at CAAB
              Airports
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5">
            <Accordion.Header>How long the GSAT remain valid?</Accordion.Header>
            <Accordion.Body>2 years</Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="6">
            <Accordion.Header>Where one can receive GSAT?</Accordion.Header>
            <Accordion.Body>
              Please contact following offices for attending CAAB approved GSAT
              <br />
              AvSecID Office, AVSEC Division HQ
              <br />
              AvSecID Office, Airport
              <br />
              Civil Aviation Training Academy
              <br />
              Smart GSAT Center located at your airport
              <br />
              Any other approved organization
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={useOfAvSecID}>
          USE OF AvSecID
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              Do I need to display my AvSecID? When? How?
            </Accordion.Header>
            <Accordion.Body>
              Yes. At all times whilst you are entering, remaining, and exiting
              Airside, Security Restricted Areas or Controlled Areas of Airport.
              The AvSecID is to be worn noticeably at chest height, facing
              forward and outer garments.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              Can I pass my AvSecID to my friend or colleague or another person
              to use because he is replacing me for work today?
            </Accordion.Header>
            <Accordion.Body>
              No. The AvSecID is not transferable. Any unauthorized possession
              or transfer of the AvSecID to another person is an offense.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              My spouse / relative is arriving from overseas. Can I use
              myAvSecID to receive him or her in the restricted areas?
            </Accordion.Header>
            <Accordion.Body>
              No. The AvSecID issued to you is for the performance of official
              duties only.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={renewal}>
          RENEWAL / RE-ISSUE OF AvSecID
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              The expiry date on my AvSecID states May 2023. When should I renew
              my Airport Pass?
            </Accordion.Header>
            <Accordion.Body>
              You should apply for the renewal of your AvSecID at least 30 days
              before the date of expiry stated on your AvSecID.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              My AvSecID has expired. Can I keep it?
            </Accordion.Header>
            <Accordion.Body>
              No. You should return your expired AvSecID to your employer or the
              Airport Pass Office or AVSEC Division, HQ.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              My name / designation /organization has been changed, should I
              have new AvSecID?
            </Accordion.Header>
            <Accordion.Body>
              Yes, <span className={styles.textUnderline}>Whenever</span> an
              individual changes their name, designation, position or
              organization, a new pass must be obtained.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={damaged}>
          DAMAGED AND CRACKED AvSecID
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              My AvSecID has cracked/damaged. Can I continue to use it?
            </Accordion.Header>
            <Accordion.Body>
              No. You should proceed to AVSEC HQ or Airport Pass Office to get a
              replacement Airport Pass. Do note that you will need to pay a
              replacement fee of 1000 Taka (inclusive of Tax and Vat).
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={lost}>
          LOST OR STOLEN AvSecID
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              What should I do if I lose my AvSecID?
            </Accordion.Header>
            <Accordion.Body>
              Any lost or stolen AvSecID shall be reported immediately to DAS of
              your organization and at the same time you should report it to
              Airport Pass Office / AVSEC Division HQ and the nearest police
              station.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              What will happen, if I don’t report my lost or stolen AvSecID?
            </Accordion.Header>
            <Accordion.Body>
              Any AvSecID not used for more than 90 days shall be deactivated
              automatically unless reported in advance and subject to further
              investigation.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              What will happen, if my AvSecID was lost due to my negligence?
            </Accordion.Header>
            <Accordion.Body>
              When a pass is lost or stolen due to negligence of a pass holder,
              the re-issue of pass shall be reviewed by Chairman, CAAB.
              Appropriate penalty in accordance with the CAAB regulations, shall
              be applied to the holder during renewal or re-issue of pass.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={foreigner}>
          I AM A FOREIGNER
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              I am a foreigner and I don't have a work permit. Can I apply for
              an AvSecID (ASP) to work in the restricted area?
            </Accordion.Header>
            <Accordion.Body>
              No, a Seasonal Airport Pass can only be issued to the applicants
              on the condition that they satisfy the requisite immigration,
              employment and/or other statutory requirements. However, if you
              are entering the restricted area for official business, you may
              apply for a One Time Visitor Pass instead on daily basis or 14
              days TASP.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={payment}>
          PAYMENT FOR AvSecID
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              What are the charges for AvSecIDs?
            </Accordion.Header>
            <Accordion.Body>
              NAP, NIAC – Not Applicable
              <br />
              CMAP – XXXXX Taka
              <br />
              PASP (91 Days - 2 years) – XXXXX Taka
              <br />
              TASP (45 to 90 Days)-XXXXX Taka
              <br />
              TASP (1-6 Days)- XXXXX Taka
              <br />
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={approval}>
          REQUIRED TIME FOR APPROVAL
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              How long must I wait to get my AvSecID?
            </Accordion.Header>
            <Accordion.Body>
              The person applying the AvSecID will receive an auto-generated
              email when the application is approved. This process usually takes
              around 25-30 working days if the background checks are completed.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={collection}>
          COLLECTING AvSecID
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              Where and when can I collect my AvSecID?
            </Accordion.Header>
            <Accordion.Body>
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>AvSecID Types</th>
                    <th>Location</th>
                    <th>Hours</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>ASP, OTPP, OTMP, OTVP, PAVP, TAVP, EAVP, LVP</td>
                    <td>Airport Pass Office</td>
                    <td>09:00 am to 2:30pm</td>
                  </tr>
                  <tr>
                    <td>NAP, NIAC, CMAP</td>
                    <td>
                      AVSEC Division, Headquarters (9th Floor), Civil Aviation
                      Authority of Bangladesh
                    </td>
                    <td>09:00 am to 02:30pm</td>
                  </tr>
                </tbody>
              </Table>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              Do I have to visit above location to collect my AvSecID?
            </Accordion.Header>
            <Accordion.Body>
              Yes, other than special circumstances, AvSecID shall be collected
              by the holder personally.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={noAvSecID}>
          I DON’T HAVE AvSecID
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              I don’t have AvSecID, How I could enter airport for my occasional
              official business?
            </Accordion.Header>
            <Accordion.Body>
              For official occasional business, you may request one of the
              following One Time security Pass (OTSP)depending on your type of
              business: <br />
              One Time Protocol Pass (OTPP) <br />
              One Time Visitor Pass (OTVP)
              <br />
              One Time Maintenance Pass (OTMP)
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>
              I don’t have AvSecID, How I could enter airport for my occasional
              official business?
            </Accordion.Header>
            <Accordion.Body>
              For official occasional business, you may request one of the
              following One Time security Pass (OTSP)depending on your type of
              business: <br />
              One Time Protocol Pass (OTPP) <br />
              One Time Visitor Pass (OTVP)
              <br />
              One Time Maintenance Pass (OTMP)
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              Who is eligible to apply for a One Time Protocol Pass (OTPP)?
            </Accordion.Header>
            <Accordion.Body>
              A person assigned to facilitate the movement of VVIPs, VIPs and
              special privileged persons in accordance with the Government
              regulations and approval. To apply
              <a
                href="http://avsec.caab.gov.bd/"
                target="_blank"
                rel="noopener noreferrer"
                className={styles.textUnderline}
              >
                click here
              </a>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>
              Who is eligible to apply for a One Time Visitor Pass (OTVP)?
            </Accordion.Header>
            <Accordion.Body>
              OTVP shall be issued to a person to facilitate approved official
              visits at the airport. To apply contact you sponsoring
              organization that are enlisted in the AvSecID Portal.
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>
              Who is eligible to apply for a One Time Maintenance Pass (OTMP)?
            </Accordion.Header>
            <Accordion.Body>
              OTMP shall be issued to facilitate the construction, development
              and maintenance activities within the airport. Concerned entity or
              department should send the request through its Designated
              Authorized Signatory (DAS).
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={cancellation}>
          CANCELLATION, SUSPENSION AND REVOCATION
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              Does CAAB has the right to cancel, suspend or revoke my AvSecID?
            </Accordion.Header>
            <Accordion.Body>
              Yes, CAAB has the right to cancel, suspend or revoke any AvSecID
              issued without assigning any reason. Any AvSecID issued under the
              authority of CAAB Chairman shall be returned to the approving or
              issuing office when required by this authority.
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>

      <>
        <h3 className={styles.subHeader} ref={documentsRequired}>
          DOCUMENTS REQUIRED DURING APPLICATION
        </h3>
        <Accordion>
          <Accordion.Item eventKey="0">
            <Accordion.Header>Airport Security Pass (ASP)</Accordion.Header>
            <Accordion.Body>
              BANGLADESH GOVERNMENT EMPLOYEE
              <ul className={`${styles.fontItalics} m-3`}>
                <li>Duly completed application on-line</li>
                <li>
                  Forwarding letter from the head of organization / division
                  with confirmation statement that the initial Background Checks
                  and Police verification Checks is conducted on the person
                </li>
                <li>Copy of national ID card </li>
                <li>Copy of employee ID card.</li>
                <li>
                  Posting order / office order for job assignment at airport
                  (initial application)
                </li>
                <li>
                  Photo (taken within 6 months) of passport quality photo as
                  specified in the application form.
                </li>
                <li>Copy of driving license (where applicable)</li>
                <li>Copy of existing permit in case of renewal</li>
                <li>GSAT Certificate (Where applicable)</li>
              </ul>
              BANGLADESHI CITIZEN (OTHER THAN GOVERNMENT EMPLOYEE)
              <ul className={`${styles.fontItalics} m-3`}>
                <li>Forwarding letter from the head of organization </li>
                <li>Duly completed application form/Apply on-line</li>
                <li>Completed Background Check by employer [Form_APP6(7)] </li>
                <li>
                  Police Verification Report from Special Branch of Bangladesh
                  Police/Completed Police Verification Form[Form_APP6(6)] [
                  Where existing police verification is valid, please collect PV
                  Confirmation receipt from AVSEC Division and upload]
                </li>
                <li>Copy of national ID and employee ID card.</li>
                <li>
                  Photo (taken within 6 months) of passport quality /as
                  specified in the application form.
                </li>
                <li>
                  Copy of valid AOC/Permission and / or Flight schedule (where
                  applicable) that is approved by CAAB [In case of new
                  operation]
                </li>
                <li>
                  Copy of agreement with CAAB or other organization (where
                  applicable).
                </li>
                <li>Copy of work order (where applicable)</li>
                <li>Copy of driving license (where applicable)</li>
                <li>Copy of existing permit (in case of renewal)</li>
                <li>GSAT Certificate (Where applicable) </li>
              </ul>
              FOREIGNERS
              <ul className={`${styles.fontItalics} m-3`}>
                <li>Forwarding letter from the head of organization </li>
                <li>Duly completed application form/Apply on-line </li>
                <li>
                  Photo (taken within 6 months) of passport quality /as
                  specified in the application form.
                </li>
                <li>
                  Copy of valid AOC/Permission and / or Flight schedule (where
                  applicable) that is approved by CAAB [In case of new
                  operation]
                </li>
                <li>
                  Copy of agreement with CAAB or other organization (where
                  applicable).
                </li>
                <li>Copy of work order (where applicable)</li>
                <li>Copy of driving license (where applicable)</li>
                <li>Copy of existing permit (in case of renewal)</li>
                <li>GSAT Certificate (Where applicable) </li>
                <li>Copy of passport and VISA</li>
              </ul>
              Additional documents for employees of Embassies and Foreign
              Mission:
              <ul className={`${styles.fontItalics} m-3`}>
                <li>
                  Forwarded by Designated Authorized Signatory (DAS) of MoFA
                </li>
                <li>Copy of note verbale issued by the mission</li>
              </ul>
              Additional documents for employees of other International
              Organization and Development Partners:
              <ul className={`${styles.fontItalics} m-3`}>
                <li>Recommendation for concerned ministry or authority </li>
              </ul>
              Additional documents for foreigner working in Bangladesh under
              Work Permit:
              <ul className={`${styles.fontItalics} m-3`}>
                <li>
                  Recommendation from Bangladesh Investment Development Agency
                  (BIDA)
                </li>
                <li>Security clearance from Ministry of Home Affairs</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="1">
            <Accordion.Header>National Airport Pass (NAP)</Accordion.Header>
            <Accordion.Body>Contact AVSEC Division, CAAB HQ</Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="2">
            <Accordion.Header>
              National Inspector Authorization Card (NIAC)
            </Accordion.Header>
            <Accordion.Body>
              <ul className={`${styles.fontItalics} m-3`}>
                <li>Forwarding letter from Member (FSR) / Member (Security)</li>
                <li>On-line application</li>
                <li>
                  Police Verification Report from Special Branch of Bangladesh
                  Police.
                </li>
                <li>Copy of national ID card </li>
                <li>
                  Letter of Authorization as CAAB Inspector from CAAB Chairman.
                </li>
                <li>
                  Photo (taken within 6 months) of passport quality/ as
                  specified in the application form.
                </li>
                <li>Copy of agreement, in case of contractual employment.</li>
                <li>Copy of driving license (where applicable)</li>
                <li>Copy of existing NIAC / pass in case of renewal</li>
                <li>GSAT Certificate (Where applicable)</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="3">
            <Accordion.Header>Crew Member Airport Pass (CMAP)</Accordion.Header>
            <Accordion.Body>
              <ul className={`${styles.fontItalics} m-3`}>
                <li>Forwarding letter from the head of organization</li>
                <li>On-line Application </li>
                <li>
                  Police Verification Report from Special Branch of Bangladesh
                  Police.
                </li>
                <li>Copy of national ID card </li>
                <li>Copy of company crew ID</li>
                <li>Copy of crew license issued by CAAB</li>
                <li>
                  Photo (taken within 6 months) of passport quality/ as
                  specified in the application form.
                </li>
                <li>Copy of agreement, in case of contractual employment.</li>
                <li>Copy of driving license (where applicable)</li>
                <li>Copy of existing CMAP/pass in case of renewal</li>
                <li>GSAT Certificate</li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="4">
            <Accordion.Header>
              Permanent Airside Vehicle Pass (PAVP)/Temporary Airside Vehicle
              Pass (TAVP)
            </Accordion.Header>
            <Accordion.Body>
              <ul className={`${styles.fontItalics} m-3`}>
                <li>Forwarding letter from head of organization </li>
                <li>Online application</li>
                <li>Copy of valid registration for each vehicle</li>
                <li>Fitness certificate from BRTA and CAAB for each vehicle</li>
                <li>
                  Color photo of vehicle (Taken from 3 angle front, back and any
                  one side) for each vehicle
                </li>
                <li>
                  Copy of driving license of driver/owner (where applicable)
                </li>
                <li>
                  Copies of existing permit in case of renewal for each vehicle
                  (where applicable)
                </li>
                <li>
                  Copy of valid insurance certificate of each vehicle/equipment.
                </li>
                <li>
                  Copy of valid pollution under control (PUC) certificate of
                  vehicle/equipment (where applicable)
                </li>
                <li>
                  Copy of speed governor installation certificate of vehicle
                  with speed set at 30 Km. ph (Where applicable)
                </li>
                <li>
                  Copy of work order/agreement/purchase order (where necessary)
                </li>

                <li>
                  Copy of lease agreement required on Taka 50/- stamp paper, if
                  the vehicle hired from another company. In that case, all
                  documents shall be endorsed by DAS of applying organization.
                </li>
                <li>
                  Justification for induction of new vehicle /equipment on
                  company letter head (where applicable)
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>

          <Accordion.Item eventKey="5">
            <Accordion.Header>
              Escorted Airside Vehicle Pass (EAVP)
            </Accordion.Header>
            <Accordion.Body>
              <ul className={`${styles.fontItalics} m-3`}>
                <li>Forwarding letter </li>
                <li>Copy of national ID and photo of the vehicle driver </li>
                <li>Supporting documents for access authorization</li>
                <li>
                  Name of the escort with AvSecID number (where applicable)
                </li>
              </ul>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </>
    </div>
  );
};

export default FAQ;
